"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = require("react");
var placeholder_png_1 = __importDefault(require("./placeholder.png"));
var react_2 = require("@emotion/react");
var getCSSRules = function (style, imageStyle, fill) {
    var _a, _b, _c, _d, _e, _f;
    return ({
        xs: {
            height: fill ? 16 : (_a = style.height) !== null && _a !== void 0 ? _a : 'auto',
            width: 16,
        },
        sm: {
            height: fill ? 24 : (_b = style.height) !== null && _b !== void 0 ? _b : 'auto',
            width: 24,
        },
        md: {
            height: fill ? 32 : (_c = style.height) !== null && _c !== void 0 ? _c : 'auto',
            width: 32,
        },
        lg: {
            height: fill ? 48 : (_d = style.height) !== null && _d !== void 0 ? _d : 'auto',
            width: 48,
        },
        xl: {
            height: fill ? 96 : (_e = style.height) !== null && _e !== void 0 ? _e : 'auto',
            width: 96,
        },
        xxl: {
            height: fill ? 128 : (_f = style.height) !== null && _f !== void 0 ? _f : 'auto',
            width: 128,
        },
        avatar: __assign({ borderRadius: '37.5%' }, style),
        image: __assign({ borderRadius: 'inherit', height: '100%', verticalAlign: 'top', width: '100%' }, imageStyle),
    });
};
var Avatar = function (_a) {
    var className = _a.className, _b = _a.fill, fill = _b === void 0 ? false : _b, _c = _a.imageStyle, imageStyle = _c === void 0 ? {} : _c, name = _a.name, onClick = _a.onClick, size = _a.size, src = _a.src, _d = _a.style, style = _d === void 0 ? {} : _d, _e = _a.styles, styles = _e === void 0 ? {} : _e;
    var classes = getCSSRules(__assign(__assign({}, styles), style), imageStyle, fill);
    var img = (0, react_1.useMemo)(function () { return src !== null && src !== void 0 ? src : placeholder_png_1.default; }, [src]);
    return ((0, jsx_runtime_1.jsx)(react_2.ClassNames, { children: function (_a) {
            var css = _a.css, cx = _a.cx;
            return ((0, jsx_runtime_1.jsx)("div", __assign({ css: css(classes.avatar), onClick: onClick, className: cx(size && css(classes[size]), className) }, { children: (0, jsx_runtime_1.jsx)("img", { css: css(__assign({ objectFit: fill ? 'cover' : 'fill' }, classes.image)), src: img, alt: name }, void 0) }), void 0));
        } }, void 0));
};
Avatar.defaultProps = {
    size: 'md',
};
exports.default = Avatar;
//# sourceMappingURL=index.js.map